<template>
    <div class="item-preview">
        <div class="item-preview__background">
            <img :src="image" alt="kasanowa" />
        </div>
        <div class="item-preview__shadow"></div>
        <KLayoutWrapper>
            <template #default>
                <div class="item-preview__wrapper">
                    <KLoader v-if="loading" />
                    <div v-if="isHtmlContent && !loading && null != content" v-html="content" />
                    <div v-if="!isHtmlContent && !loading && null != content">
                        {{ content }}
                    </div>
                </div>
                <div class="item-preview__btn-wrapper">
                    <KButton
                        id="back-btn"
                        :label="btnTitle"
                        icon="arrowRight"
                        width="20"
                        height="20"
                        red
                        uppercase
                        @click="btnClick"
                    />
                </div>
            </template>
        </KLayoutWrapper>
    </div>
</template>

<script setup lang="ts">
import { defineProps, onMounted } from 'vue';
import KLayoutWrapper from '@/components/atoms/KLayoutWrapper.vue';
import KLoader from '@/components/atoms/KLoader.vue';
import KButton from '@/components/atoms/KButton.vue';

interface IOwnProps {
    content: string
    image: string
    loading: boolean
    btnClick: () => void
    btnTitle: string
    isHtmlContent?: boolean
}
interface IProps extends IOwnProps {
}

defineProps<IProps>();

onMounted(() => {
    window.scrollTo(0, 0);
});
</script>

<style scoped lang="scss">
.item-preview {
    position: relative;
    background-color: $primary-900;

    &__background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;

        img {
            object-fit: cover;
            width: 100%;
            height: 400px;

            @include media-breakpoint-up(lg) {
                height: 600px;
            }
        }
    }

    &__shadow {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 400px;
        // Gradient od przezroczystego na górze do białego na dole
        background: linear-gradient(
                to bottom,
                transparent 0%,
                transparent 60%,
                rgba($primary-900, 0.3) 75%,
                rgba($primary-900, 0.7) 85%,
                rgba($primary-900, 0.9) 92%,
                $primary-900 100%
        );

        @include media-breakpoint-up(lg) {
            height: 600px;
            background: linear-gradient(
                    to bottom,
                    transparent 0%,
                    transparent 70%,
                    rgba($primary-900, 0.2) 80%,
                    rgba($primary-900, 0.6) 88%,
                    rgba($primary-900, 0.9) 95%,
                    $primary-900 100%
            );
        }
    }

    &__wrapper {
        width: 100%;
        max-width: 100%;
        padding: 15px;
        background-color: $white;
        margin-top: 235px;
        min-height: 300px;

        @include media-breakpoint-up(lg) {
            margin-top: 350px;
            padding: 25px;
        }
    }

    &__btn-wrapper {
        display: flex;
        width: max-content;
        margin: 20px auto 0;
    }
}
</style>
